//for use in "guards" data for securing a route, when using the MasterGuardService; defines the sub-guards that ought to be applied
export enum GuardList {
    BaseGuardService,
    InstantiateFlowGuardService,
    InternalGuardService,
    OrganizationGuardService,
    SystemPermissionGuardService,
    ViewDashGuardService,
    HomeGuardService
}